function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8536 9.14645C23.6583 8.95118 23.3417 8.95118 23.1464 9.14645C22.9512 9.34171 22.9512 9.65829 23.1464 9.85355C24.2815 10.9886 24.875 12.7242 24.875 14.5C24.875 16.2758 24.2815 18.0114 23.1464 19.1464C22.9512 19.3417 22.9512 19.6583 23.1464 19.8536C23.3417 20.0488 23.6583 20.0488 23.8536 19.8536C25.2185 18.4886 25.875 16.4742 25.875 14.5C25.875 12.5258 25.2185 10.5114 23.8536 9.14645ZM21.8536 11.1464C21.6583 10.9512 21.3417 10.9512 21.1464 11.1464C20.9512 11.3417 20.9512 11.6583 21.1464 11.8536C21.7815 12.4886 22.125 13.4742 22.125 14.5C22.125 15.5258 21.7815 16.5114 21.1464 17.1464C20.9512 17.3417 20.9512 17.6583 21.1464 17.8536C21.3417 18.0488 21.6583 18.0488 21.8536 17.8536C22.7185 16.9886 23.125 15.7242 23.125 14.5C23.125 13.2758 22.7185 12.0114 21.8536 11.1464ZM12 15C12 12.7909 13.7909 11 16 11C18.2091 11 20 12.7909 20 15C20 17.2091 18.2091 19 16 19C13.7909 19 12 17.2091 12 15ZM9 22C9 20.8869 9.90315 20 11.0087 20L21 20C22.1045 20 23 20.8956 23 22C23 23.6912 22.1672 24.9663 20.865 25.7966C19.583 26.614 17.8547 27 16 27C14.1453 27 12.417 26.614 11.135 25.7966C9.83281 24.9663 9 23.6912 9 22Z",
  fill: "#217BC7"
});

function SvgWhisper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhisper);
export default __webpack_public_path__ + "static/media/whisper.81387a2d.svg";
export { ForwardRef as ReactComponent };